jQuery(function ($) {
  const mobileMenuOpen = $("#mobile-menu-open");
  const mobileMenuClose = $("#mobile-menu-close");
  const mobilePanel = $("#mobile-menu");
  const body = $("body");

  // Get focusable elements inside panel
  function getFocusableElements(container) {
    return container.find(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    ).filter(":visible");
  }

  function trapFocus(e) {
    const focusableEls = getFocusableElements(mobilePanel);
    if (!focusableEls.length) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        // shift + tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }
  }

  mobileMenuOpen.on("click", function () {
    // console.log("mobile menu open");
    mobilePanel.removeClass("hidden").addClass("active");
    body.addClass("mobile-no-scroll");

    // focus first focusable element in panel
    const focusableEls = getFocusableElements(mobilePanel);
    if (focusableEls.length) {
      focusableEls[0].focus();
    }

    // trap focus listener
    $(document).on("keydown", trapFocus);
  });

  mobileMenuClose.on("click", function () {
    // console.log("mobile menu close");
    mobilePanel.removeClass("active").addClass("hidden");
    body.removeClass("mobile-no-scroll");

    // return focus to open button
    mobileMenuOpen.focus();

    // remove trap
    $(document).off("keydown", trapFocus);
  });
});
